import { render, staticRenderFns } from "./noContent.vue?vue&type=template&id=307257f7&scoped=true&"
import script from "./noContent.vue?vue&type=script&lang=js&"
export * from "./noContent.vue?vue&type=script&lang=js&"
import style0 from "./noContent.vue?vue&type=style&index=0&id=307257f7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307257f7",
  null
  
)

export default component.exports